import React, { useEffect, useState } from 'react';

import Modal from 'react-modal';
import { useNavigate } from 'react-router-dom';
import Toggle from 'react-toggle';
import 'react-toggle/style.css';

import { CheckCircleOutlined } from '@ant-design/icons';

import moment from 'moment';
import { Line } from 'rc-progress';

import BnplModal from './Bnpl/BnplModal';

import BackIcon from '../assets/images/arrow-back.svg';
import closeIcon from '../assets/images/close.svg';
import '../assets/styles/loan/LoanBanner.scss';
import configData from '../config';
import { switchPaymentInstrumentForLoan } from '../service/loan';

const LoanBanner = ({ paymentInstrument, data, loan }) => {
  const navigate = useNavigate();
  const [autoPay, setAutoPay] = useState(true);
  const [newValue, setNewValue] = useState(autoPay);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    setAutoPay(loan?.autoPayEnabled);
  }, [loan]);

  if (!data) {
    return null;
  }

  const handleBackClick = () => {
    navigate('/dashboard');
  };

  const isBnpl = configData.getTenant() === 'lightrx';

  const toggleAutoPay = (value) => {
    setNewValue(value);
    setOpenConfirmModal(true);
  };

  const closeModal = () => {
    setOpenConfirmModal(false);
  };

  const confirmToggleAutoPay = async () => {
    setAutoPay(newValue);
    closeModal();
    const data = {
      autoPayEnabled: newValue,
      payeeId: loan?.payeeId,
      autoPayInstrumentId: paymentInstrument[0].instrumentId,
    };
    try {
      await switchPaymentInstrumentForLoan(data, loan.servicingLoanId);
    } catch (err) {
      console.log(err);
      setError('There is an error updating autopay');
    }
  };

  return (
    <div className="loanBannerContainer ant-layout-content">
      <div className="loanBannerBlock">
        <div className={`row ${isBnpl && 'lightrx'}`}>
          <div className="loanBannerBack">
            {!isBnpl && (
              <button className="loanBannerBackButton" onClick={handleBackClick}>
                <img src={BackIcon} alt="back" />
              </button>
            )}
          </div>
          <div className="loanBannerTitle">Loan #{data.acctrefno}</div>
          <div className="row loanBannerDue">
            <div className="loanBannerDueDate">
              Due {moment(data.nextPaymentDate).format('MMMM D, YYYY')}
            </div>
            <div className="loanBannerDuePayment">
              {data?.nextPaymentDue?.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
              })}
            </div>
          </div>
          <button
            className="btn primary-btn loanBannerAction"
            onClick={() => {
              navigate(`/account/${data.acctrefno}/payment`, undefined, {
                shallow: true,
              });
            }}
          >
            Make One Time Payment
          </button>
        </div>
      </div>
      <div className="loanBannerGray">
        <div className="loanBannerBlock">
          <div className="row">
            <div>
              <div className="loanBannerAutopay">
                {configData?.dashboard?.toggleAutoPay ? (
                  <>
                    AutoPay
                    {paymentInstrument?.length && (
                      <Toggle
                        checked={autoPay}
                        className="autopay-switch"
                        icons={{
                          checked: <span>On</span>,
                          unchecked: <span>Off</span>,
                        }}
                        onChange={(e) => toggleAutoPay(e.target.checked)}
                      />
                    )}
                  </>
                ) : (
                  <>
                    Auto Pay On
                    <CheckCircleOutlined />
                  </>
                )}
              </div>
            </div>
            <div>
              <Line
                percent={
                  ((data.currentNoteAmount - data.currentPrincipalBalance) /
                    data.currentNoteAmount) *
                  100
                }
                strokeColor="#5fb7b5"
                trailColor="#EAEAEA"
                strokeWidth="2"
                trailWidth="2"
              />
              <div className="loanBannerBar">
                <div className="loanBannerPoint">
                  <span>Paid</span>
                  <strong>
                    {(data.currentNoteAmount - data.currentPrincipalBalance).toLocaleString(
                      'en-US',
                      {
                        style: 'currency',
                        currency: 'USD',
                      }
                    )}
                  </strong>
                </div>
                <div className="loanBannerPoint">
                  <span>Remaining</span>
                  <strong>
                    {data.currentPrincipalBalance.toLocaleString('en-US', {
                      style: 'currency',
                      currency: 'USD',
                    })}
                  </strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal isOpen={openConfirmModal} className="loan-modal" onRequestClose={closeModal}>
        <div className="modal-header">
          <img className="close-icon" onClick={closeModal} src={closeIcon} alt="close-icon" />
        </div>
        <div className="modal-content">
          <h3 className="text-center">
            You are about to switch the Auto Pay to {newValue ? 'On' : 'Off'}.<br />
            Are you sure?
          </h3>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn primary-btn" onClick={confirmToggleAutoPay}>
            Yes
          </button>
          <button type="button" className="btn primary-btn" onClick={closeModal}>
            No
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default LoanBanner;
